<div class="dialog dialog-small dialog-flex-direction-column retirement-benefit-dialog">
    <h4 class="dialog-inner h4-blue">Retirement Contribution Benefit</h4>
    <div class="dialog-inner">While you are disabled and receiving benefits under this policy, a
        contribution will be made to your retirement account up to the
        amount selected below for the selected number of months. The
        actual payment will be the lesser of this selection or the amount you
        are regularly putting into retirement immediately prior to the date of
        disability.</div>

    <div class="dialog-inner semibold">Additional Annual Cost</div>
   <div class="cost">{{cost ? (cost | currency) : 'Calculating...'}}</div>
    <!--
    <br />
    <mat-label class="label-text">Monthly Contribution Amount</mat-label>
    -->
    <br />
    <mat-form-field>
        <mat-label class="label-text">Monthly Amount</mat-label>
        <mat-select [(ngModel)]="RCBAmount" [disabled]="RCBAmountOptions.length <= 1" (selectionChange)="updateCost()">
            <mat-option *ngIf="RCBAmountOptions.length <=1" value="{{RCBAmount}}">${{RCBAmount}}</mat-option>
            @for ( item of RCBAmountOptions; track item ) {
            <mat-option value="{{item}}">${{item}}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <!--
    <mat-label class="label-text">Maximum Benefit Duration</mat-label>
    <br />
    -->
    <mat-form-field>
        <mat-label class="label-text">Maximum Duration</mat-label>
        <mat-select [(ngModel)]="RCBDuration" [disabled]="RCBDurationOptions.length <= 1"
            (selectionChange)="updateCost()">
            <mat-option *ngIf="RCBDurationOptions.length <=1" value="{{RCBDuration}}">{{RCBDuration}}</mat-option>
            @for ( item of RCBDurationOptions; track item ) {
            <mat-option value="{{item}}">{{item}}</mat-option>
            }
        </mat-select>
    </mat-form-field>

    <!--<div class="dialog-inner">Would you like to add this benefit to your policy?</div> -->
    <div *ngIf="!inclusion()" class="dialog-inner-buttons">
        <button class="button-mgis" (click)="no()" class="chat-button chat-button-define" mat-flat-button>Cancel</button>
        <button class="button-mgis" (click)="yes()" class="chat-button chat-button-define" mat-flat-button>Add to Policy</button>

    </div>
    <div *ngIf="inclusion()" class="dialog-inner-buttons">
        <button class="button-mgis" (click)="yes()" class="chat-button chat-button-define" mat-flat-button>Close</button>
    </div>
    <br/>